<template>
  <div class="relative flex w-3 flex-col items-center lg:w-5">
    <div class="min-h-5 w-0.5 flex-1 bg-hazel-300"></div>
    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="0,0 8,0 4,10" class="fill-hazel-300" />
    </svg>
  </div>
</template>
